module.exports = __webpack_public_path__ + "img/exit.de5afba9.svg";